module.exports = __webpack_public_path__ + "static/img/8.1080e5a.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/img/ods/flags/8.jpg
// module id = LrMQ
// module chunks = 15